import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=6089cd12"
import script from "./Levels.vue?vue&type=script&lang=js"
export * from "./Levels.vue?vue&type=script&lang=js"
import style0 from "./Levels.vue?vue&type=style&index=0&id=6089cd12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports